.grid {
    display: flex;
}
